import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';


import { GenericListUICDTO, GenericListUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { UICMasterType } from 'src/app/Common/UICServices/uic.enum';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { SalesDetailDTO } from 'src/app/sale/sales/sales-detail/sales-detail.interface';
import { SalesDetailService } from 'src/app/sale/sales/sales-detail/sales-detail.service';
import { SalesMasterDTO, SalesMasterSearchByInvoiceNoRequestDTO } from 'src/app/sale/sales/sales.inteface';
import { SalesMasterService } from 'src/app/sale/sales/sales.service';


@Component({
  selector: 'app-add-via-sales-invoice-button',
  templateUrl: './add-via-sales-invoice-button.component.html',
  styleUrls: ['./add-via-sales-invoice-button.component.css']
})
export class AddViaSalesInvoiceButtonComponent {

  ngOnInit(): void {
    this.SalesInvoiceNo.valueChanges.subscribe(res => {
      console.log(res);
      if (res && Number(res) > 1) {
        this.GetItemsBySalesDetailId(Number(res))
      }
    })

    this.GetTableUI()
  }

  @Output() onSubmit: EventEmitter<SalesDetailDTO[]> = new EventEmitter<SalesDetailDTO[]>();

  @Input({ required: true }) MasterId: number = 0
  @Input({ required: true }) MasterType: string = ''

  gListUICService = inject(GenericListUicService);
  SalesDetailItems: SalesDetailDTO[] = []; // table
  SelectedDetailItems: SalesDetailDTO[] = [];
  @Input() EnablePriceEdit: boolean = false



  salesMasterService = inject(SalesMasterService)
  salesDetailService = inject(SalesDetailService)
  User = inject(UserLoginService).User()
  SalesInvoiceList: SalesMasterDTO[] = []; // search 
  prdListUIC: GenericListUICDTO[] = []
  dataLoading: boolean = false
  submitResults() {
    this.isSubmitting = true
    this.onSubmit.emit(this.SelectedDetailItems)

  }

  SalesInvoiceNo = new FormControl('')

  title = 'Sales Invoice'
  ReleaseModalRef!: NgbModalRef
  isSubmitting: boolean = false
  @ViewChild('ReleaseItemModal', { static: true }) ReleaseModalTemplate!: ElementRef

  modalService = inject(NgbModal)
  searchLoading: boolean = false;

  openModal() {
    this.SalesInvoiceNo.reset()
    this.SelectedDetailItems = []
    this.SalesDetailItems = []
    this.SalesInvoiceList = []
    this.searchLoading = true;
    let data: SalesMasterSearchByInvoiceNoRequestDTO = {
      invoiceNo: '',
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }
    this.salesMasterService.SalesMaster_SearchByInvoiceNo(data).subscribe(res => {
      this.SalesInvoiceList = res.items
      this.searchLoading = false;
    })
    this.ReleaseModalRef = this.modalService.open(this.ReleaseModalTemplate, { size: 'lg', backdrop: 'static' })
  }

  SearchSalesInvoice(event: { term: string; items: any[]; }) {
    console.log(event.term);
    setTimeout(() => {

      this.searchLoading = true;
      let data: SalesMasterSearchByInvoiceNoRequestDTO = {
        invoiceNo: event.term,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      }
      this.salesMasterService.SalesMaster_SearchByInvoiceNo(data).subscribe(res => {

        this.SalesInvoiceList = []
        this.SalesInvoiceList = res.items
        this.searchLoading = false;
      })
    }, 500);
  }


  GetItemsBySalesDetailId(invoiceId: number) {
    this.dataLoading = true
    // Switching invoice: drop ticks from the previous one so they aren't imported with this one
    this.SelectedDetailItems = []
    this.salesDetailService.SalesDetail_ReadByInvoiceIdForImport({
      invoiceId, masterId: this.MasterId, masterType: this.MasterType,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    }).subscribe(res => {
      this.SalesDetailItems = []
      this.SalesDetailItems = res.items
      this.dataLoading = false

    })
  }

  GetTableUI() {
    let data: GenericListUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.SalesDetailList,
      tenantId: this.User.companyId
    }

    this.gListUICService.GenericListUIC_ReadByTenantId(data).subscribe(res => {
      this.prdListUIC = res.items
    })
  }




  onSelctionCheckboxChange(event: any, item: SalesDetailDTO) {
    item.isSelected = event.target.checked
    let isDuplicate = this.SelectedDetailItems.find(i => i.itemId == item.itemId)

    if (event.target.checked) {
      if (!isDuplicate)
        this.SelectedDetailItems.push(item)
    } else {
      this.SelectedDetailItems = this.SelectedDetailItems.filter(i => i.itemId != item.itemId)
    }

    console.log(this.SelectedDetailItems);
  }


  onSelectAllCheckboxChange(event: any) {
    if (event.target.checked) {
      // Clear previous selections
      this.SelectedDetailItems = [];

      // Mark all items as selected
      this.SalesDetailItems.forEach(i => i.isSelected = true);

      // Copy all items into SelectedDetailItems
      this.SelectedDetailItems = [...this.SalesDetailItems];
    } else {
      // Uncheck all
      this.SalesDetailItems.forEach(i => i.isSelected = false);
      this.SelectedDetailItems = [];
    }
    console.log(this.SelectedDetailItems);
  }


  get ifItemsSelected() {
    return this.SelectedDetailItems.length > 0
  }

  patchCommonPrice(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    console.log('Entered value:', value);

    // Convert to number if needed
    const numValue = Number(value);
    this.SelectedDetailItems.forEach(i => { i.price = numValue })

  }
}
